<script>
  import ApolloLoginConfirm from "@/public/pages/apollo/apolloLoginConfirm.vue";
  import LoginConfirm from "@/public/pages/login-confirm.vue";

  const APOLLO_PRODUCT_NAME = 'Apollopayment';
  const envProductName = import.meta.env.VITE_PRODUCT_NAME
  export default {
    name: "LoginContainer",
    computed: {
      component () {
        return envProductName !== APOLLO_PRODUCT_NAME ? LoginConfirm : ApolloLoginConfirm;
      }
    }
  }
</script>

<template>
  <component :is="component" />
</template>
